// extracted by mini-css-extract-plugin
module.exports = {"snoozedPage":"snoozedOffers_snoozedPage__1V0_-","offerBody":"snoozedOffers_offerBody__n6nIB"};